import {
  GET_SETTINGS,
  GET_SETTINGS_FAILURE,
  GET_SETTINGS_SUCCESS,
  UPDATE_SETTINGS,
  UPDATE_SETTINGS_FAILURE,
  UPDATE_SETTINGS_SUCCESS,
} from "../types";

export const getSettings = (payload) => ({
  type: GET_SETTINGS,
  payload
});
export const getSettingsSuccess = (payload) => ({
  type: GET_SETTINGS_SUCCESS,
  payload,
});
export const getSettingsFailure = (payload) => ({
  type: GET_SETTINGS_FAILURE,
  payload,
});

export const updateSettings = (payload) => ({
  type: UPDATE_SETTINGS,
  payload,
});
export const updateSettingsSuccess = (payload) => ({
  type: UPDATE_SETTINGS_SUCCESS,
  payload,
});
export const updateSettingsFailure = (payload) => ({
  type: UPDATE_SETTINGS_FAILURE,
  payload,
});
